
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/term-and-condition",
      function () {
        return require("private-next-pages/term-and-condition/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/term-and-condition"])
      });
    }
  